#import "./lead-goal-condition-fragment.graphql"

fragment LeadEmailAutomation on EmailAutomation {
    id
    delay {
        unit
        timespan
    }
    entersStage {
        id
        name
    }
    emailList {
        id
        ... on MailChimpList {
            name
        }
        ... on ConstantContactList {
            name
        }
        ... on EmailSequenceTemplate {
            id
            name
            emailSequenceTemplateMessages {
                id
            }
        }
    }
}

fragment LeadStagesEdge on LeadStagesEdge {
    node {
        id
        description
        name
    }
    avatarUrl
    chevronAvatarUrl
    isActive
    timeInStage {
        formattedString
    }
    goalConditions {
        ...LeadGoalCondition
    }
    unfiredEmailAutomations {
        ...LeadEmailAutomation
    }
    emailAutomationStatuses {
        id
        status
        isPaused
        canCancel
        unsentMessageCount
        canStart
        sender {
            id
            name
            sendableEmailAddresses {
                id
                isEnabledForSending
            }
        }
        emailAutomation {
            ...LeadEmailAutomation
        }
        emailSequence {
            id
            messageCount
            emailsQueued {
                id
                isAlreadySent
                isNextScheduledEmail
                subject
                deliveryTime
                htmlUrl
            }
            nextUnsentEmail {
                id
            }
            emailSequenceTemplate {
                id
                creatorUser {
                    id
                }
            }
        }
        firstName {
            required
            value
        }
        lastName {
            required
            value
        }
        companyName {
            required
            value
        }
        lead {
            id
            contacts {
                primaryEdge {
                    node {
                        id
                        name
                        emailAddresses {
                            primary {
                                value {
                                    address
                                }
                            }
                        }
                    }
                }
            }
            assignee {
                id
            }
        }
    }
}
